import Vue from 'vue'
import SlideUpDown from 'vue-slide-up-down'

import UiBtn from '~/components/ui/UiBtn'
import UiLink from '~/components/ui/UiLink'
import UiAlert from '~/components/ui/UiAlert'
import UiBadge from '~/components/ui/UiBadge'
import UiText from '~/components/ui/UiText'
import UiSkeleton from '~/components/ui/UiSkeleton'

import ModalLink from '@/modal/core/ModalLink'
import ModalComponent from '@/modal/core/BaseModal'

Vue.component('SlideUpDown', SlideUpDown)

Vue.component('UiBtn', UiBtn)
Vue.component('UiLink', UiLink)
Vue.component('UiAlert', UiAlert)
Vue.component('UiBadge', UiBadge)
Vue.component('UiText', UiText)
Vue.component('UiSkeleton', UiSkeleton)

Vue.component('ModalLink', ModalLink)
Vue.component('ModalComponent', ModalComponent)
